module.exports = __webpack_public_path__ + "img/logo_cl.f15e8d35.png";